import { pipe } from 'rxjs';
import { filter, map, pluck } from 'rxjs/operators';

// Parse an id from params
export function parseId<T>(paramName: string = 'id') {
  return pipe(
    map<T, number>((params) => parseInt(params[paramName], 10)),
    filter((id) => !isNaN(id))
  );
}

// Parse a gid from params
export function parseGid<T>(paramName: string = 'gid') {
  return pluck<T, string>(paramName);
}
